// extracted by css-extract-rspack-plugin
export default {"label":"Label__label--dCvU7"};